import { Component, Input } from "@angular/core";
import { PolicyTabStats } from "@/_models/stats-policy.interface";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";

@Component({
    selector: "app-policy-type-stats",
    standalone: true,
    imports: [SharedComponentsModule],
    templateUrl: "./policy-type-stats.component.html",
})
export class PolicyTypeStatsComponent {
    @Input() data: PolicyTabStats;
}
